"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethereum_block_by_date_1 = __importDefault(require("ethereum-block-by-date"));
const BaseWatcher_1 = __importStar(require("./BaseWatcher"));
const models_1 = require("../models");
const luxon_1 = require("luxon");
const eventTopics_1 = require("../constants/eventTopics");
class L2ToL2Watcher extends BaseWatcher_1.default {
    watch() {
        this.start().catch((err) => this.ee.emit('error', err));
        return this.ee;
    }
    async start() {
        await this.startBase();
        return this.poll(await this.pollFn());
    }
    async pollFn() {
        try {
            // here the await is intential so it's handled by the catch if it fails
            return await this.wrapperWatcher();
        }
        catch (err) {
            // console.error(err)
            return this.ammWatcher();
        }
    }
    async wrapperWatcher() {
        const l2Dest = await this.bridge.getL2Bridge(this.destinationChain);
        let transferHash = '';
        for (const log of this.sourceReceipt.logs) {
            if (log.topics[0] === eventTopics_1.transferSentTopic) {
                transferHash = log.topics[1];
                break;
            }
        }
        if (!transferHash) {
            return false;
        }
        const filter = l2Dest.filters.WithdrawalBonded();
        const handleEvent = async (...args) => {
            const event = args[args.length - 1];
            const decodedLog = event.decode(event.data, event.topics);
            if (transferHash === decodedLog.transferId) {
                if (!this.sourceBlock.timestamp) {
                    return false;
                }
                const destTx = await event.getTransaction();
                if (!destTx) {
                    return false;
                }
                const destBlock = await this.destinationChain.provider.getBlock(destTx.blockNumber);
                if (!destBlock) {
                    return false;
                }
                const destTxReceipt = await this.destinationChain.provider.waitForTransaction(destTx.hash);
                this.ee.emit(BaseWatcher_1.Event.Receipt, {
                    chain: this.destinationChain,
                    receipt: destTxReceipt
                });
                this.ee.emit(BaseWatcher_1.Event.DestinationTxReceipt, {
                    chain: this.destinationChain,
                    receipt: destTxReceipt
                });
                l2Dest.off(filter, handleEvent);
                return true;
            }
            return false;
        };
        l2Dest.on(filter, handleEvent);
        let tailBlock;
        const batchBlocks = this.destinationChain === models_1.Chain.Polygon ? 500 : 1000;
        return async () => {
            var _a;
            let headBlock = (_a = this.options) === null || _a === void 0 ? void 0 : _a.destinationHeadBlockNumber;
            if (!headBlock) {
                headBlock = await this.destinationChain.provider.getBlockNumber();
            }
            if (!tailBlock) {
                const blockDater = new ethereum_block_by_date_1.default(this.destinationChain.provider);
                const date = luxon_1.DateTime.fromSeconds(this.sourceBlock.timestamp - (60 * 60)).toJSDate();
                const info = await blockDater.getDate(date);
                if (info) {
                    tailBlock = info.block;
                }
            }
            if (!headBlock) {
                return false;
            }
            const getRecentLogs = async (start, end) => {
                var _a;
                if (end > headBlock) {
                    end = headBlock;
                    start = end - batchBlocks;
                }
                if (end <= start) {
                    return [];
                }
                const events = ((_a = (await l2Dest.queryFilter(filter, start, end))) !== null && _a !== void 0 ? _a : []).reverse();
                tailBlock = start + batchBlocks;
                if (events.length) {
                    return events;
                }
                return getRecentLogs(tailBlock, end + batchBlocks);
            };
            const events = await getRecentLogs(tailBlock, tailBlock + batchBlocks);
            for (const event of events) {
                if (await handleEvent(event)) {
                    return true;
                }
            }
            return false;
        };
    }
    async ammWatcher() {
        // events for token swap on L2 (ie saddle convert page on UI)
        const amm = this.bridge.getAmm(this.destinationChain);
        const swap = await amm.getSaddleSwap();
        let startBlock = -1;
        let endBlock = -1;
        const filter = swap.filters.TokenSwap();
        const handleEvent = async (...args) => {
            const event = args[args.length - 1];
            const decodedLog = event.decode(event.data, event.topics);
            if (this.sourceTx.from === decodedLog.buyer) {
                if (!this.sourceBlock.timestamp) {
                    return false;
                }
                const destTx = await event.getTransaction();
                if (!destTx) {
                    return false;
                }
                const destBlock = await this.destinationChain.provider.getBlock(destTx.blockNumber);
                if (!destBlock) {
                    return false;
                }
                if (destBlock.timestamp - this.sourceBlock.timestamp < 500) {
                    if (await this.emitDestTxEvent(destTx)) {
                        swap.off(filter, handleEvent);
                        return true;
                    }
                }
            }
            return false;
        };
        swap.on(filter, handleEvent);
        return async () => {
            var _a;
            const blockNumber = await this.destinationChain.provider.getBlockNumber();
            if (!blockNumber) {
                return false;
            }
            if (startBlock === -1) {
                startBlock = endBlock - 100;
            }
            else {
                startBlock = endBlock;
            }
            endBlock = blockNumber;
            const events = ((_a = (await swap.queryFilter(filter, startBlock, endBlock))) !== null && _a !== void 0 ? _a : []).reverse();
            if (!events || !events.length) {
                return false;
            }
            for (const event of events) {
                if (await handleEvent(event)) {
                    return true;
                }
            }
            return false;
        };
    }
}
exports.default = L2ToL2Watcher;
